import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { api as backDashboardApi } from './back-dashboard-api';
import { graphApi } from './graph';
import { appConfigSlice } from './features/app-config/slice';
import { localStorage as appConfigLocalStorage } from './features/app-config/middlewares';
import { localStorage as shoppingBagLocalStorage } from './features/shopping-bag/middlewares';
import { sessionSlice } from './features/session/slice';
import { shoppingBagSlice } from './features/shopping-bag/slice';
import { rtkQueryErrorLogger } from './middlewares';

export const rootReducer = combineReducers({
  appConfigSlice: appConfigSlice.reducer,
  sessionSlice: sessionSlice.reducer,
  shoppingBagSlice: shoppingBagSlice.reducer,
  [graphApi.reducerPath]: graphApi.reducer,
  [backDashboardApi.reducerPath]: backDashboardApi.reducer,
});

export function setupStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat([
        appConfigLocalStorage.middleware,
        shoppingBagLocalStorage.middleware,
        graphApi.middleware,
        backDashboardApi.middleware,
        rtkQueryErrorLogger,
      ]),
  });
}

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
